/* eslint-env jquery */

"use strict";

const processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./product/details"));
    processInclude(require("./product/initXZoom"));
    processInclude(require("plugin_instorepickup/product/pdpInstoreInventory"));
    processInclude(require("plugin_giftregistry/product/giftRegistry"));
    processInclude(require("./components/swatchHide"));
});
